import ChevronLeft from './ChevronLeft';
import ChevronRightThin from './ChevronRightThin';
import Close from './Close';
import Facebook from './Facebook';
import Instagram from './Instagram';
import Search from './Search';
import Share from './Share';
import Twitter from './Twitter';
import Burger from 'ui/Icon/icons/Burger';
import Checkmark from 'ui/Icon/icons/Checkmark';
import Envelope from 'ui/Icon/icons/Envelope';

type IconRepositoryType = {
  [index: string]: any;
};

const IconRepository: IconRepositoryType = {
  Burger: Burger,
  Checkmark: Checkmark,
  ChevronLeft: ChevronLeft,
  ChevronRightThin: ChevronRightThin,
  Close: Close,
  Envelope: Envelope,
  Facebook: Facebook,
  Instagram: Instagram,
  Share: Share,
  Search: Search,
  Twitter: Twitter,
};

export default IconRepository;
